import axios from "axios";
import { useEffect, useState } from "react";

const DEFAULT_PHOTOGRAPHER = "Endu";

const fetchPhotosStatus = (slug, params, signal) =>
  axios
    .get(`${window._env_.REACT_PUBLIC_ENDPOINT}/events/${slug}/photos/status`, {
      params,
      signal,
    })
    .then(({ data }) => data);

const usePhotosEdition = (slug, editionId, checkDefaultEdition) => {
  const [photosEdition, setPhotosEdition] = useState({
    isDefaultEdition: false,
    photographer: DEFAULT_PHOTOGRAPHER,
  });

  useEffect(() => {
    if (!slug || !editionId) return undefined;

    const controller = new AbortController();
    const loadPhotosEdition = async () => {
      const defaultStatus = checkDefaultEdition
        ? await fetchPhotosStatus(slug, {}, controller.signal)
        : undefined;
      const isDefaultEdition = defaultStatus?.eventDetail?.id === editionId;
      const editionStatus = isDefaultEdition
        ? defaultStatus
        : await fetchPhotosStatus(slug, { editionId }, controller.signal);

      setPhotosEdition({
        isDefaultEdition,
        photographer: editionStatus.organization?.name || DEFAULT_PHOTOGRAPHER,
      });
    };

    loadPhotosEdition().catch((error) => {
      if (!axios.isCancel(error)) console.error(error);
    });

    return () => controller.abort();
  }, [slug, editionId, checkDefaultEdition]);

  return photosEdition;
};

export default usePhotosEdition;
